<template>
    <q-page>
        <div class="q-pa-md">
            <div class="text-h4">{{ this.persona.Nombre }}</div>
            <q-btn flat color="primary" label="Regresar" to="/personal" @click="this.$router.push('/personal')" />
            <q-form class="q-gutter-md" @submit.prevent="guardaDatos">
                <div class="row">
                    <div class="col-md-12">
                        <q-input class="m-3" borderless disable dense v-model="persona.Adscripcion.Descripcion"
                            label="Adscripción" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.Categoria.Descripcion"
                            label="Categoría" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="tipoEmpleado" label="Tipo Empleado" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.Enlace" label="Num. Epleado" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.Plaza" label="Plaza" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.RFC" label="RFC" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.CURP" label="CURP" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="fechaAlta" type="date"
                            label="Ingreso a Gobierno" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" borderless disable dense v-model="persona.AñosLaborados"
                            label="Años Laborados" />
                    </div>
                    <div class="col-md-4">
                        <q-toggle class="m-3" dense v-model="persona.Activo" label="Checa" left-label/>
                    </div>
                    <div class="col-md-12">
                        <q-select class="m-3" outlined option-value="IdAdscripcion" use-input input-debounce="0"
                            option-label="Descripcion" dense v-model="persona.IdComision" :options="filtro"
                            @filter="filterFn" option-disable="inactive" emit-value map-options label="Comisión">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section class="text-grey">
                                        Sin resultados
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" dense borderless disable v-model="persona.NIP" label="NIP" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdLugarChecado" option-label="Descripcion" dense
                            v-model="persona.IdLugarChecado" :options="lugaresChecado" option-disable="inactive"
                            emit-value map-options label="Lugar de Checado" />
                    </div>
                    <div class="col-md-4">
                        <q-input class="m-3" outlined dense v-model="persona.Extension" label="Telefono / Extensión" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Lunes" :options="horarios" option-disable="inactive" emit-value map-options
                            label="Lunes" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Martes" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Martes" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Miercoles" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Miercoles" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Jueves" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Jueves" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Viernes" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Viernes" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Sabado" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Sabado" />
                    </div>
                    <div class="col-md-4">
                        <q-select class="m-3" outlined option-value="IdHorarioLaboral" option-label="Horario" dense
                            v-model="persona.Domingo" :options="horarios" option-disable="inactive" emit-value
                            map-options label="Domingo" />
                    </div>
                    <div class="col-md-4">
                        <q-btn color="primary" label="Guardar" type="submit" v-if="!valUser.SoloLectura"/>
                    </div>
                </div>
            </q-form>
            <div class="row">
                <div class="col-md-12">
                    <div class="text-h6">Observaciones</div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <q-table dense :pagination="{ rowsPerPage: 5 }" :rows-per-page-options="[0]" virtual-scroll flat
                        bordered :rows="observaciones" separator="cell">
                        <template v-slot:header>
                            <q-tr class="bg-dark text-white">
                                <q-th key="Descripcion" align="left">Descripción</q-th>
                                <q-th key="Fecha" auto-width align="left">Fecha</q-th>
                                <q-th auto-width key="Actions" align="center">
                                    <!--<q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editLugarChecado(0)"/>-->
                                    <q-btn icon="add" color="dark" size="sm" padding="5px 5px" v-if="!valUser.SoloLectura"
                                        @click="CargaObservacion(0)" />
                                </q-th>
                            </q-tr>
                        </template>
                        <template v-slot:body="props">
                            <q-tr>
                                <q-td style="white-space:pre-line">{{ props.row.Descripcion }}</q-td>
                                <q-td auto-width>{{ new Date(props.row.Fecha).toISOString().slice(0, 10) }}</q-td>
                                <q-td>
                                    <q-btn-group>
                                        <!--<q-btn icon="edit" color="secondary" size="sm" padding="5px 5px" @click="editLugarChecado(props.row.IdLugarChecado)"/>
                                        <q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showLugarChecado(props.row.IdLugarChecado)"/>-->
                                    </q-btn-group>
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </div>
            </div>
        </div>
        <q-dialog v-model="bObs" persistent>
            <q-card style="width: 700px; max-width: 80vw;">
                <q-toolbar class="bg-dark text-white">
                    <q-toolbar-title>Observación</q-toolbar-title>
                    <q-btn flat round dense icon="close" v-close-popup />
                </q-toolbar>
                <q-card-section>
                    <q-form class="q-gutter-md" @submit.prevent="GuardaObservacion">
                        <div class="row">
                            <div class="col col-md-12">
                                <q-input class="m-3" outlined dense v-model="observacion.Descripcion"
                                    label="Observación" type="textarea" :rules="rules" />
                            </div>
                        </div>
                        <div>
                            <div class="q-pa-md q-gutter-sm float-right">
                                <q-btn color="secondary" text-color="white" label="Cerrar" @click="bObs = false" />
                                <q-btn color="primary" label="Guardar" type="submit" />
                            </div>
                        </div>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>
    </q-page>


</template>
<script>
import {mapState} from 'vuex';
import http from "@/services/http"
import rs from '@/services/routerStore';

export default {
    data: () => ({
        rfc: '',
        persona: {},
        horarios: [],
        lugaresChecado: [],
        adscripciones: [],
        filtro: [],
        observaciones: [],
        observacion: {},
        bObs: false,
        tipoEmpleado: '',
        fechaAlta: new Date().toISOString().slice(0, 10),
        rules: [v => !!v || 'Campo obligatorio',],
    }),
    methods: {
        async initialize() {
            this.rfc = this.$route.params.rfc
            this.cargaHorario()
            this.cargaLugarChecado()
            this.cargaAdscripciones()
            this.cargaDatos()
        },
        tipoEmp() {
            switch (this.persona.IdTipoEmpleado) {
                case 1:
                    return 'BASE'
                case 2:
                    return 'CONFIANZA'
                case 3:
                    return 'PROGRAMAS ESPECIALES'
                default:
                    return 'DESCONOCIDO'
            }
        },
        async guardaDatos() {
            await http.post('personal/datos', this.persona);
            rs.alert({ color: 'positive', message: 'Datos Guardados' })
            this.cargaDatos()
        },
        async cargaObservaciones() {
            this.observaciones = await http.get(`personal/observaciones/${this.rfc}`)
        },
        CargaObservacion(id) {
            this.observacion = { IdObservaciones: 0, RFC: this.rfc, Descripcion: "" }
            this.bObs = true
        },
        async GuardaObservacion() {
            await http.post('personal/observacion', this.observacion);
            this.bObs = false;
            this.cargaObservaciones()
        },
        async cargaLugarChecado() {
            this.lugaresChecado = await http.get('catalogos/lugaresChecado')
        },
        async cargaHorario() {
            this.horarios = await http.get('catalogos/horarios')
        },
        async cargaAdscripciones() {
            this.adscripciones = await http.get('catalogos/adscripciones')
            this.filtro = this.adscripciones
        },
        async cargaDatos() {
            if (this.rfc.trim() != "") {
                this.persona = await http.get(`personal/datos/${this.rfc}`)
                //console.log(this.persona);
                this.tipoEmpleado = this.tipoEmp()
                this.fechaAlta = new Date(this.persona.FechaAltaGobierno).toISOString().slice(0, 10)
                this.cargaObservaciones()
            }
        },
        filterFn(val, update, abort) {
            update(() => {
                const needle = val.toLowerCase();
                this.filtro = this.adscripciones.filter(p => p.Descripcion.toLowerCase().indexOf(needle) > -1);

            });
        },
    },
    computed:{
            ...mapState(['user']),
            valUser(){
              return this.user
            }
        },
    created() {
        this.initialize();
    },
    
}
</script>
